import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CreateGeographicNodeDto,
  GeographicNode,
  GeographicNodeListDto,
  GeographicNodeResponse,
  GeographicNodeValidateResponse,
} from './geographic-node.model';

@Injectable({
  providedIn: 'root',
})
export class GeographicNodesService {
  private http = inject(HttpClient);
  private basePath = 'geographic-nodes';

  findAll(filters: GeographicNodeListDto): Observable<GeographicNodeResponse> {
    let params = new HttpParams();

    if (filters.page !== undefined) {
      params = params.set('page', filters.page.toString());
    }
    if (filters.limit !== undefined) {
      params = params.set('limit', filters.limit.toString());
    }
    if (filters.search) {
      params = params.set('search', filters.search);
    }
    if (filters.status) {
      params = params.set('status', filters.status);
    }
    if (filters.level) {
      params = params.set('level', filters.level);
    }
    if (filters.parent_id) {
      params = params.set('parent_id', filters.parent_id);
    }

    return this.http.get<GeographicNodeResponse>(`/${this.basePath}`, { params });
  }

  deactivate(id: string): Observable<GeographicNode> {
    return this.http.patch<GeographicNode>(`/${this.basePath}/${id}/deactivate`, {});
  }

  activate(id: string): Observable<GeographicNode> {
    return this.http.patch<GeographicNode>(`/${this.basePath}/${id}/activate`, {});
  }

  validateName(name: string, parentId?: string): Observable<GeographicNodeValidateResponse> {
    let params = new HttpParams().set('name', name);
    if (parentId) {
      params = params.set('parent_id', parentId);
    }
    return this.http.get<GeographicNodeValidateResponse>(`/${this.basePath}/validate`, { params });
  }

  validateCode(code: string, level: string): Observable<GeographicNodeValidateResponse> {
    const params = new HttpParams().set('code', code).set('level', level);
    return this.http.get<GeographicNodeValidateResponse>(`/${this.basePath}/validate`, { params });
  }

  create(dto: CreateGeographicNodeDto): Observable<GeographicNode> {
    return this.http.post<GeographicNode>(`/${this.basePath}`, dto);
  }

  getAncestors(id: string): Observable<GeographicNode[]> {
    return this.http.get<GeographicNode[]>(`/${this.basePath}/${id}/ancestors`);
  }
}
